import { useCallback, useState } from 'react';
import { pushDataLayerClick } from '../shared/utils';
export const useTracking = toolInfo => {
  const [hasFirstInteraction, setHasFirstInteraction] = useState(false);
  const trackFirstInteraction = useCallback(() => {
    if (!hasFirstInteraction) {
      pushDataLayerClick({
        toolInfo,
        itemText: 'tool use'
      });
      setHasFirstInteraction(true);
    }
  }, [hasFirstInteraction, toolInfo]);
  return {
    trackFirstInteraction,
    toolInfo
  };
};

///////// IMPLEMENTATION /////////

/*
 * Defines the values which will be set in the dataLayer
 * Where sensible, for existing tools these should match the values from which-static-content
 * Otherwise inform the analytics team of the new values
 * */